import * as XLSX from "xlsx";

export interface ParsedSheet {
  rows: any[];
  fileType: "csv" | "xlsx";
}

/**
 * Helper para carregar arquivos nos formatos csv, xlsx e xls
 */
export async function importSpreadsheet(
  file: File,
  separator: string = ";"
): Promise<ParsedSheet> {
  const name = file.name.toLowerCase();

  // --- CSV: read as UTF-8 string ---
  if (name.endsWith(".csv")) {
    const buffer = await file.arrayBuffer();

    const bytes = new Uint8Array(buffer);

    const isUtf8Bom =
      bytes[0] === 0xef && bytes[1] === 0xbb && bytes[2] === 0xbf;

    const decoder = new TextDecoder(isUtf8Bom ? "utf-8" : "windows-1252");

    const text = decoder.decode(buffer);

    const workbook = XLSX.read(text, {
      type: "string",
      raw: true,
      codepage: 65001,
      FS: separator,
      WTF: false,
    });

    const sheet = workbook.Sheets[workbook.SheetNames[0]];

    const rows = XLSX.utils.sheet_to_json(sheet, {
      defval: "",
      blankrows: false,
      raw: true,
    });

    return { rows, fileType: "csv" };
  }

  // --- XLSX/XLS ---
  else if (name.endsWith(".xlsx") || name.endsWith(".xls")) {
    const data = await file.arrayBuffer();

    const workbook = XLSX.read(data, {
      type: "array",
      raw: false,
      cellDates: true,
      dateNF: "yyyy-mm-dd",
    });

    const sheet = workbook.Sheets[workbook.SheetNames[0]];

    const rows = XLSX.utils.sheet_to_json(sheet, {
      defval: "",
      blankrows: false,
      raw: false,
    });

    return { rows, fileType: "xlsx" };
  }

  throw new Error(
    "Formato de arquivo inválido. Apenas CSV, XLSX, ou XLS são permitidos."
  );
}
